import React, {ReactNode} from "react";

import cx from "classnames";

import styles from "./LoadingSkeleton.scss";

type LoadingSkeletonProps = {
  className?: string;
  children?: ReactNode;
  isLoading: boolean;
};

export default function LoadingSkeleton({
  className,
  children,
  isLoading,
}: LoadingSkeletonProps): JSX.Element {
  if (!isLoading) {
    // children can be undefined, so wrapped to fragment
    return <>{children}</>;
  }

  return <div className={cx(styles.loadingSkeleton, className)}></div>;
}
